var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconNativeSpeakers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 86.5 86.5",
    width: 86,
    height: 86,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#205763",
    d: "M0 0h86.5v86.5H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#205763",
    fillRule: "evenodd",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.269 76.18a2.607 2.607 0 1 1 2.6 4.519 43.25 43.25 0 1 1 0-74.9 2.607 2.607 0 1 1-2.6 4.519 38.016 38.016 0 1 0 0 65.86M70.132 16.368a2.616 2.616 0 0 1 3.7-3.7 43.274 43.274 0 0 1 0 61.163 2.616 2.616 0 0 1-3.7-3.7 37.989 37.989 0 0 0 0-53.763"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.73 23.76a2.61 2.61 0 0 1 3.7-3.681 32.78 32.78 0 0 1 0 46.342 2.61 2.61 0 1 1-3.7-3.681 27.552 27.552 0 0 0 0-38.98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.33 31.161a2.61 2.61 0 0 1 3.7-3.681 22.311 22.311 0 0 1 0 31.54 2.61 2.61 0 0 1-3.7-3.681 17.085 17.085 0 0 0 0-24.178M25.961 78.58c1.305-6.892 4.857-9.193 7.871-9.678 3.707-.6 8.41.391 11.509-2.837 1.941-2.021.138-4.337-.3-7.079-.377-2.388-.423-2.795-.056-3.844a.926.926 0 0 0-.866-1.342l-5.486.1c1.846-.983 3.455-1.814 5.292-2.816a.828.828 0 0 0 .212-1.419c-1.331-1.18-.679-3.019-.026-4.709.824-2.131 7.432-1.955 4.1-6.674-4.112-5.825-6.871-9.081-8.084-15.4a37.648 37.648 0 0 0-7.133-16.729c-.187-.241-.379-.478-.569-.716a39.351 39.351 0 0 0-28.5 37.816 43.049 43.049 0 0 0 1.808 11.821 39.436 39.436 0 0 0 20.229 23.51"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNativeSpeakers);
export default __webpack_public_path__ + "static/media/icon-native-speakers.d435bde82695e511d3eddb7fa0612097.svg";
export { ForwardRef as ReactComponent };